export default function initTooltips() {
  const tooltipContainers = document.querySelectorAll(
    ".program-detail__event-tooltip-container",
  );

  tooltipContainers.forEach((tooltip) => {
    const triggerBtn = tooltip.querySelector(
      ".program-detail__event-tooltip-trigger",
    );
    const closeBtn = tooltip.querySelector(
      ".program-detail__event-tooltip-close",
    );
    const tooltipBody = tooltip.querySelector(".program-detail__event-tooltip");

    triggerBtn.addEventListener("click", () => {
      tooltipBody.classList.add("visible");
      closeBtn.focus();
    });

    triggerBtn.addEventListener("focus", () => {
      tooltipBody.classList.add("visible");
      closeBtn.focus();
    });

    closeBtn.addEventListener("click", () => {
      tooltipBody.classList.remove("visible");
    });

    closeBtn.addEventListener("focusout", () => {
      tooltipBody.classList.remove("visible");
    });

    document.body.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && tooltipBody.classList.contains("visible")) {
        tooltipBody.classList.remove("visible");
      }
    });
  });
}
